<div class="container-fluid container-xxl gx-0 my-13">
    <div>
        <div class="col-md-8 mx-auto col-11 fs-md-15 fs-14">
            <h5 class="text-center fw-700">{{ 'PRIVACY_POLICY.title' | translate }}</h5>
            <h5 class="text-start fw-700 mt-10">{{ 'PRIVACY_POLICY.CHAPTER-1.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">
                    {{ 'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-1.title-1' | translate }}
                    <a [routerLink]="['/'] | localize">{{ currentDomain }}</a>
                    {{ 'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-1.title-2' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                <div class="col-11">
                    <p>{{ 'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-2.title' | translate }}</p>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.a.' | translate }}</span>
                        <p class="col-11" [innerHtml]="'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-2.SUB-SECTION-1.title' | translate"></p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.b.' | translate }}</span>
                        <p class="col-11">
                            <span [innerHtml]="'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-2.SUB-SECTION-2.title' | translate"></span>&nbsp;
                            <a [routerLink]="['/'] | localize">{{ currentDomain }}</a
                            >.
                        </p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.c.' | translate }}</span>
                        <p class="col-11" [innerHtml]="'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-2.SUB-SECTION-3.title' | translate"></p>
                    </div>
                </div>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end"> {{ 'NUMBERS.3.' | translate }}</span>
                <p class="col-11">
                    {{ 'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-3.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.4.' | translate }}</span>
                <div class="col-11">
                    <p>
                        {{ 'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-4.title' | translate }}
                    </p>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.a.' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-4.SUB-SECTION-1.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.b.' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-4.SUB-SECTION-2.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.c.' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-4.SUB-SECTION-3.title' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end"> {{ 'NUMBERS.5.' | translate }}</span>
                <p class="col-11">
                    {{ 'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-5.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end"> {{ 'NUMBERS.6.' | translate }}</span>
                <p class="col-11">
                    {{ 'PRIVACY_POLICY.CHAPTER-1.SUB-CHAPTER-6.title' | translate }}
                </p>
            </div>
            <h5 class="text-start fw-700 mt-8">{{ 'PRIVACY_POLICY.CHAPTER-2.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end"> {{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">
                    {{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-1.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end"> {{ 'NUMBERS.2.' | translate }}</span>

                <div class="col-11">
                    <p>
                        {{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-2.title' | translate }}
                    </p>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.a)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-2.SUB-SECTION-1.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.b)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-2.SUB-SECTION-2.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.c)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-2.SUB-SECTION-3.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.d)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-2.SUB-SECTION-4.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.e)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-2.SUB-SECTION-5.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.f)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-2.SUB-SECTION-6.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.g)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-2.SUB-SECTION-7.title' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end"> {{ 'NUMBERS.3.' | translate }}</span>

                <div class="col-11">
                    <p>
                        {{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-3.title' | translate }}
                    </p>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.a)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-3.SUB-SECTION-1.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.b)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-3.SUB-SECTION-2.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.c)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-3.SUB-SECTION-3.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.d)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-3.SUB-SECTION-4.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.e)' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-3.SUB-SECTION-5.title' | translate }}</p>
                    </div>
                </div>
                <div class="mt-2 row">
                    <span class="col-1 text-end"> {{ 'NUMBERS.4.' | translate }}</span>
                    <div class="col-11">
                        <p>
                            {{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-4.title' | translate }}
                        </p>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.a)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-4.SUB-SECTION-1.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.b)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-4.SUB-SECTION-2.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.c)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-4.SUB-SECTION-3.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.d)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-4.SUB-SECTION-4.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.e)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-4.SUB-SECTION-5.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.f)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-4.SUB-SECTION-6.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.g)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-4.SUB-SECTION-7.title' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="mt-2 row">
                    <span class="col-1 text-end"> {{ 'NUMBERS.5.' | translate }}</span>
                    <p class="col-11">
                        {{ 'PRIVACY_POLICY.CHAPTER-2.SUB-CHAPTER-5.title' | translate }}
                    </p>
                </div>
                <h5 class="text-start fw-700 mt-8">
                    {{ 'PRIVACY_POLICY.CHAPTER-3.title' | translate }}
                </h5>
                <div class="mt-8 row">
                    <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                    <div class="col-11">
                        <p>
                            {{ 'PRIVACY_POLICY.CHAPTER-3.SUB-CHAPTER-1.title' | translate }}
                        </p>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.a)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-3.SUB-CHAPTER-1.SUB-SECTION-1.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.b)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-3.SUB-CHAPTER-1.SUB-SECTION-2.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.c)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-3.SUB-CHAPTER-1.SUB-SECTION-3.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.d)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-3.SUB-CHAPTER-1.SUB-SECTION-4.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.e)' | translate }}</span>
                            <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-3.SUB-CHAPTER-1.SUB-SECTION-5.title' | translate }}</p>
                        </div>
                    </div>
                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-3.SUB-CHAPTER-2.title' | translate }}</p>
                    </div>
                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'NUMBERS.3.' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-3.SUB-CHAPTER-3.title' | translate }}</p>
                    </div>
                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'NUMBERS.4.' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-3.SUB-CHAPTER-4.title' | translate }}</p>
                    </div>
                    <h5 class="text-start fw-700 mt-8">
                        {{ 'PRIVACY_POLICY.CHAPTER-4.title' | translate }}
                    </h5>
                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-4.SUB-CHAPTER-1.title' | translate }}</p>
                    </div>
                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-4.SUB-CHAPTER-2.title' | translate }}</p>
                    </div>
                    <h5 class="text-start fw-700 mt-8">
                        {{ 'PRIVACY_POLICY.CHAPTER-5.title' | translate }}
                    </h5>
                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-5.SUB-CHAPTER-1.title' | translate }}</p>
                    </div>
                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                        <p class="col-11">{{ 'PRIVACY_POLICY.CHAPTER-5.SUB-CHAPTER-2.title' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
